import React from 'react';
import XLSIconComponent from '../../../../../src/assets/images/studio/data-source/xls.svg';

interface XLSIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  style?: React.CSSProperties;
}

export default function XLSIcon({ style, ...props }: XLSIconProps) {
  return <img {...props} alt="xls icon" src={XLSIconComponent} style={{ ...style }} />;
}
